// extracted by mini-css-extract-plugin
export default {"mainWrapper":"instructions_mainWrapper__yIG0w","boxWrapper":"instructions_boxWrapper__CxlQi","rowWrapper":"instructions_rowWrapper__eJcvV"};